/* eslint-disable array-callback-return */
/* eslint-disable no-shadow */
/* eslint-disable prefer-destructuring */
import { call, all, put, takeLatest } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import * as Actions from './actions';
import * as Constants from './Constants';
import * as getCheckoutActions from '../../pages/FuncComp/sagas.helper';
import { eventDispatcher, updateToAEP } from '../../components/common/Tagging';
import * as notificationActions from '../../components/common/NotificationBar/actions';
import * as addonsActions from '../../pages/Addons/actions';
import * as shippingActions from '../../pages/ShippingInfo/actions';
import * as actionTypes from '../../pages/ProgressivePlans/@Redux/actionTypes';
import { store } from '../../configureStore';
import {
  setSession,
  removeOneDuplicate,
  getAPPID,
  getSession,
  isWHW,
  enablePegaProcessSteps,
  GetCurrentPageName,
  GetProcessStepPages,
  isWWM,
  isFuncComp,
  isExpressCheckout,
  isExpressCheckoutFLow,
  prefetchGetCheckoutAndSmsEnabled,
  giftCardOfferAPI,
  getPageName,
  isMiniCartFooterEnabled,
  isJTFlowFromNGDCart,
  isLoggedIn,
  isBeaconUpgradeFlow,
  getWHWSPODetails,
  getWHWSpoId,
  isEnableFwaRedesignFFlag,
} from '../../components/common/Helpers';
import logger from '../../components/common/ErrorBoundary/logger_new';
import { getProductRefData } from '../../utils/plansReference/index';
import { checkInvalidCaseCartError } from '../../components/common/Helpers/commonLog';
import { showLoader, hideLoader } from '../../components/common/Helpers/loader';
import { apiUrls } from '../../constants/apiUrl';
import * as deviceSetupActions from '../../pages/DeviceSetup/actions';
import { isAppointmentSetupEnabled } from '../../components/common/Helpers/sessionUtils';
import { getCheckOutDetails } from '../../pages/FuncComp/actions.js';
import { fetchSMSEnabledDevices } from '../../pages/ShippingInfo/actions.js';
import { FIR_TAG_NO, FIR_TAG_YES, PROGRESSIVE_PLANS_PAGE } from '../../components/Web/Cart/redesign/Components/constant.js';
import { EXPRESS_CHECKOUT_DETAILS_PREFETCH } from '../../components/NextGen/ExpressCheckout/@Redux/actionTypes';

const handleShowLoader = (prefetchValidateCart, skipLoader) => {
  if (!skipLoader && prefetchValidateCart !== 'cart' && prefetchValidateCart !== 'prefetechOrderReviewValCart') {
    showLoader();
  }
};

const getBeaconUpgradeAccessoryPayload = (data) => {
  const whwDetails = getWHWSPODetails();
  const spoId =
    data?.addWHWPlan?.whwProdId ||
    getWHWSpoId(
      whwDetails?.spoDetails?.find(
        (spo) =>
          spo?.categoryCode === Constants.WHW_BASIC_CATEGORY ||
          getWHWSpoId(spo) === Constants.WHW_BASIC_SPO_ID,
      ),
    );
  if (!spoId) {
    return null;
  }

  return {
    value: Constants.WHW_EXTENDER_ACTION,
    qty: data?.addWHWPlan?.whwQty || '1',
    routerSku: whwDetails?.extSku || Constants.WHW_DEFAULT_EXTENDER_SKU,
    spoId,
    selectedCategory: data?.addWHWPlan?.selectedCategory || data?.selectedCategory,
    incOrDec: data?.addWHWPlan?.incrementButtonFlag,
  };
};

const handleHideLoader = (prefetchValidateCart, skipLoader) => {
  if (!skipLoader && prefetchValidateCart !== 'cart' && prefetchValidateCart !== 'prefetechOrderReviewValCart') {
    hideLoader();
  }
};

export function* getCartDetails({ data, prefetchValidateCart, skipLoader }) {
  let errorDetails = false;
  yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
  yield put({ type: Constants.CEF_CART_ERROR, response: false, errorMessage: null });
  const notifyErrorMessage = data;
  handleShowLoader(prefetchValidateCart, skipLoader);
  yield put({ type: Constants.ASYNC_FETCH });
  yield put(notificationActions.hideNotification());
  try {
    yield put({ type: 'UPDATE_API_STATUS', response: 'IN_PROGRESS' });
    if (prefetchValidateCart === 'prefetechOrderReviewValCart') {
      yield put({ type: 'PREFETCH_ORDERREVIEW_STATUS', response: 'IN_PROGRESS' });
    }
    const apiResponse = yield call(Actions.getCartDetails, { pageName: data, prefetchValidateCart });
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      yield put({ type: Constants.GET_CART_SUCCESS, response: apiResponse.data });
      yield put({ type: 'UPDATE_API_STATUS', response: 'COMPLETED' });
      if (prefetchValidateCart === 'prefetechOrderReviewValCart') {
        yield put({ type: 'PREFETCH_ORDERREVIEW_STATUS', response: 'COMPLETED' });
      }
    } else {
      if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
        errorDetails = true;
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `getCartDetails ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);
        yield put({ type: 'UPDATE_API_STATUS', response: 'FAILED' });
        if (prefetchValidateCart === 'prefetechOrderReviewValCart') {
          yield put({ type: 'PREFETCH_ORDERREVIEW_STATUS', response: 'FAILED' });
        }

        yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
      }
      yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
      yield put(notificationActions.showErrorNotification(notifyErrorMessage));
    }
  } catch (error) {
    yield put({ type: 'UPDATE_API_STATUS', response: 'FAILED' });
    if (prefetchValidateCart === 'prefetechOrderReviewValCart') {
      yield put({ type: 'PREFETCH_ORDERREVIEW_STATUS', response: 'FAILED' });
    }
  }

  handleHideLoader(prefetchValidateCart, skipLoader);
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

/**
 *  This saga method is used to reset the cart
 * @param {data} param0
 */
function* removeLines({ data }) {
  let errorDetails = false;
  let cartInvalidError = false;
  yield put({ type: Constants.ASYNC_FETCH });
  showLoader();
  try {
    const apiResponse = yield call(Actions.removeLines);
    if (apiResponse && apiResponse.status === 200 && !apiResponse?.data.errors) {
      yield put({ type: Constants.WIFI_UPDATE_CART, data });
    } else {
      if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
        if (apiResponse?.status === 400 && checkInvalidCaseCartError(apiResponse.data.errors)) {
          cartInvalidError = true;
        } else {
          errorDetails = true;
        }
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `remove-lines ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);
        hideLoader();
        yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
      }
      yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
      yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
      hideLoader();
    }
  } catch (error) {
    if (error && error.response) {
      errorDetails = true;
      yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
      yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
      hideLoader();
    }
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

/**
 *  This saga method is used to update the cart in case user
 *  switching between the primary plans and wifi plans.
 * @param {data} param0
 */
function* updateCart({ data }) {
  let errorDetails = false;
  let cartInvalidError = false;
  yield put({ type: Constants.ASYNC_FETCH });
  showLoader();
  try {
    const apiResponseWifiBackup = yield call(Actions.updateCart, data);
    if (apiResponseWifiBackup && apiResponseWifiBackup.status === 200 && !apiResponseWifiBackup?.data.errors) {
      // The redesign reads the cart to decide which plans show as added, so it has to be re-read
      // after updateCart or the page would still reflect the pre-switch plan.
      if (isEnableFwaRedesignFFlag()) {
        yield call(Actions.getCartDetails, { pageName: data?.pageName || '' });
      }
      yield put({ type: Constants.PROGRESSIVE_PLANS_API, data: { value: true, processingMDN: '', exploreType: data?.exploreType || '' } });
    } else {
      if (
        apiResponseWifiBackup &&
        ((apiResponseWifiBackup.data && apiResponseWifiBackup.data.errors) ||
          (apiResponseWifiBackup.request && apiResponseWifiBackup.request.status !== 200))
      ) {
        if (apiResponseWifiBackup?.status === 400 && checkInvalidCaseCartError(apiResponseWifiBackup.data.errors)) {
          cartInvalidError = true;
        } else {
          errorDetails = true;
        }
        if (apiResponseWifiBackup.data.loggerData)
          apiResponseWifiBackup.data.loggerData.note = `wifiBackup ${apiResponseWifiBackup?.data?.loggerData.note}`;
        logger(apiResponseWifiBackup?.data?.loggerData);
        hideLoader();
        yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: apiResponseWifiBackup?.data?.errors[0]?.notifyMessage });
      }
      yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
      yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
      hideLoader();
    }
  } catch (error) {
    if (error && error.response) {
      errorDetails = true;
      yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
      yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
      hideLoader();
    }
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* showCart(value) {
  yield put({ type: Constants.UPDATE_SHOW_CART, data: value.data });
}

function* addToCart({ data, actionType, oddOnList, updateType, pageName, payLoadObj, cb }) {
  yield put({ type: EXPRESS_CHECKOUT_DETAILS_PREFETCH, response: 'RESET' });
  let errorDetails = false;
  let cartInvalidError = false;
  let addonsInvalidError = false;
  yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
  yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
  yield put({ type: 'ADDON_INVALIDCASE_ERROR', response: addonsInvalidError });
  yield put({ type: Constants.CEF_CART_ERROR, response: false, errorMessage: null });
  yield put({ type: 'ADD_FEATURES_REMOVE_LOADED', response: false });
  const notifyErrorMessage = data.notifyMessage;
  let oddOnListArr = oddOnList;
  yield put(notificationActions.hideNotification());
  showLoader();

  const isCallBackNeeded = cb && typeof cb === 'function';

  switch (actionType) {
    case 'streamingDevice':
      yield put({ type: Constants.ASYNC_FETCH });
      try {
        showLoader();
        const apiResponseAddAccessories = yield call(Actions.getAddAccessories, data);
        const { data: dataStreamingDevice, request, status = '' } = apiResponseAddAccessories || {};

        if (status === 200 && !dataStreamingDevice.errors) {
          showLoader();
          yield call(Actions.getCartDetails, { pageName, validCouponResponse: data });

          if (updateType === 'addToCart') {
            oddOnListArr.push('streamingDevice');
          } else if (updateType === 'removeFromCart') {
            oddOnListArr = removeOneDuplicate(oddOnList, 'streamingDevice');
          }
          store.dispatch({ type: 'SET_ADDONS', oddOnListArr });
          if (isCallBackNeeded) {
            cb();
          }
          hideLoader();
        } else {
          if (dataStreamingDevice?.errors || request?.status !== 200) {
            if (status === 400 && checkInvalidCaseCartError(dataStreamingDevice.errors)) {
              cartInvalidError = true;
              addonsInvalidError = true;
            } else {
              errorDetails = true;
            }

            if (dataStreamingDevice?.loggerData) {
              dataStreamingDevice.loggerData.note = `streamingDevice ${dataStreamingDevice.loggerData.note}`;
              logger(dataStreamingDevice.loggerData);
            }

            hideLoader();
            yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: dataStreamingDevice?.errors?.[0]?.notifyMessage });
          }

          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
          yield put({ type: 'ADDON_INVALIDCASE_ERROR', response: addonsInvalidError });
          yield put(notificationActions.showErrorNotification(notifyErrorMessage));
        }
      } catch (errorAddAccessories) {
        hideLoader();
        if (errorAddAccessories?.response) {
          errorDetails = true;
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
        }
      }
      yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
      break;
    case 'WHWExtender':
      yield put({ type: Constants.ASYNC_FETCH });
      try {
        showLoader();
        const apiResAddAccessoriesWHWExt = yield call(Actions.getAddAccessories, data);
        if (apiResAddAccessoriesWHWExt && apiResAddAccessoriesWHWExt.status === 200 && !apiResAddAccessoriesWHWExt.data.errors) {
          showLoader();
          yield call(Actions.getCartDetails, data);
          if (updateType === 'addToCart') {
            oddOnListArr.push('WHWExtender');
          }
          store.dispatch({ type: 'SET_ADDONS', oddOnListArr });
          store.dispatch({ type: 'SELECTED_WHW_CATEGORY', value: data?.selectedCategory });
          hideLoader();
        } else {
          if (
            apiResAddAccessoriesWHWExt &&
            ((apiResAddAccessoriesWHWExt.data && apiResAddAccessoriesWHWExt.data.errors) ||
              (apiResAddAccessoriesWHWExt.request && apiResAddAccessoriesWHWExt.request.status !== 200))
          ) {
            if (apiResAddAccessoriesWHWExt?.status === 400 && checkInvalidCaseCartError(apiResAddAccessoriesWHWExt.data.errors)) {
              cartInvalidError = true;
              addonsInvalidError = true;
            } else {
              errorDetails = true;
            }

            if (apiResAddAccessoriesWHWExt.data.loggerData)
              apiResAddAccessoriesWHWExt.data.loggerData.note = `WHWExtender ${apiResAddAccessoriesWHWExt?.data?.loggerData.note}`;
            logger(apiResAddAccessoriesWHWExt?.data?.loggerData);
            hideLoader();
            yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: apiResAddAccessoriesWHWExt?.data?.errors[0]?.notifyMessage });
          }
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails, notifyErrorMsg: apiResAddAccessoriesWHWExt?.data?.errors?.[0]?.message });
          yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
          yield put({ type: 'ADDON_INVALIDCASE_ERROR', response: addonsInvalidError });
          yield put(notificationActions.showErrorNotification(notifyErrorMessage));
        }
      } catch (errWHWExtAddAccessories) {
        hideLoader();
        if (errWHWExtAddAccessories?.response) {
          errorDetails = true;
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
        }
      }
      yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
      break;
    case 'WHW':
      yield put({ type: Constants.ASYNC_FETCH });
      try {
        showLoader();
        const apiResAddAccessoriesWHW = yield call(Actions.getAddAccessories, 'WHW');
        if (apiResAddAccessoriesWHW && apiResAddAccessoriesWHW.status === 200 && !apiResAddAccessoriesWHW.data.errors) {
          showLoader();
          yield put({ type: Constants.GET_REVIEW_ORDER });
          if (updateType === 'addToCart') {
            oddOnListArr.push('WHW');
          }
          store.dispatch({ type: 'SET_ADDONS', oddOnListArr });
          hideLoader();
        } else {
          if (
            apiResAddAccessoriesWHW &&
            ((apiResAddAccessoriesWHW.data && apiResAddAccessoriesWHW.data.errors) ||
              (apiResAddAccessoriesWHW.request && apiResAddAccessoriesWHW.request.status !== 200))
          ) {
            if (apiResAddAccessoriesWHW?.status === 400 && checkInvalidCaseCartError(apiResAddAccessoriesWHW.data.errors)) {
              cartInvalidError = true;
              addonsInvalidError = true;
            } else {
              errorDetails = true;
            }

            if (apiResAddAccessoriesWHW.data.loggerData)
              apiResAddAccessoriesWHW.data.loggerData.note = `WHW ${apiResAddAccessoriesWHW?.data?.loggerData.note}`;
            logger(apiResAddAccessoriesWHW?.data?.loggerData);
            hideLoader();
            yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: apiResAddAccessoriesWHW?.data?.errors[0]?.notifyMessage });
          }
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails, notifyErrorMsg: apiResAddAccessoriesWHW?.data?.errors?.[0]?.message });
          yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
          yield put({ type: 'ADDON_INVALIDCASE_ERROR', response: addonsInvalidError });
          yield put(notificationActions.showErrorNotification(notifyErrorMessage));
        }
      } catch (errWHWAddAccessories) {
        hideLoader();
        if (errWHWAddAccessories?.response) {
          errorDetails = true;
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
        }
      }
      yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
      break;

    case 'streamingService':
      yield put({ type: Constants.ASYNC_FETCH });
      try {
        showLoader();
        const apiResponseAddYttv = yield call(Actions.getAddYttv, data);
        if (apiResponseAddYttv && apiResponseAddYttv.status === 200 && !apiResponseAddYttv.data.errors) {
          showLoader();
          yield call(Actions.getCartDetails, { pageName, validCouponResponse: data });

          if (updateType === 'addToCart') {
            oddOnListArr.push('streamingService');
          }
          if (updateType === 'removeFromCart') {
            oddOnListArr = removeOneDuplicate(oddOnList, 'streamingService');
            store.dispatch({ type: 'ADD_FEATURES_REMOVE_LOADED', response: true });
          }
          store.dispatch({ type: 'SET_ADDONS', oddOnListArr });
          if (isCallBackNeeded) {
            cb();
          }
          hideLoader();
        } else {
          if (
            apiResponseAddYttv &&
            ((apiResponseAddYttv.data && apiResponseAddYttv.data.errors) || (apiResponseAddYttv.request && apiResponseAddYttv.request.status !== 200))
          ) {
            if (apiResponseAddYttv?.status === 400 && checkInvalidCaseCartError(apiResponseAddYttv.data.errors)) {
              cartInvalidError = true;
              addonsInvalidError = true;
            } else {
              errorDetails = true;
            }
            if (apiResponseAddYttv.data.loggerData)
              apiResponseAddYttv.data.loggerData.note = `streamingService ${apiResponseAddYttv?.data?.loggerData.note}`;
            logger(apiResponseAddYttv?.data?.loggerData);
            hideLoader();
            yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: apiResponseAddYttv?.data?.errors[0]?.notifyMessage });
          }
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
          yield put({ type: 'ADDON_INVALIDCASE_ERROR', response: addonsInvalidError });
          yield put(notificationActions.showErrorNotification(notifyErrorMessage));
          hideLoader();
        }
      } catch (errorAddYttv) {
        hideLoader();
        if (errorAddYttv?.response) {
          errorDetails = true;
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
        }
      }
      yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
      break;

    case 'cartRemove':
      try {
        const apiResponseCartRemove = yield call(Actions.getAddAccessories, data);
        if (apiResponseCartRemove && apiResponseCartRemove.status === 200 && !apiResponseCartRemove.data.errors) {
          showLoader();
          yield call(Actions.getCartDetails, { pageName: data });
          yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
          hideLoader();
        } else {
          if (
            apiResponseCartRemove &&
            ((apiResponseCartRemove.data && apiResponseCartRemove.data.errors) ||
              (apiResponseCartRemove.request && apiResponseCartRemove.request.status !== 200))
          ) {
            if (apiResponseCartRemove?.status === 400 && checkInvalidCaseCartError(apiResponseCartRemove.data.errors)) {
              cartInvalidError = true;
              addonsInvalidError = true;
            } else {
              errorDetails = true;
            }

            if (apiResponseCartRemove.data.loggerData)
              apiResponseCartRemove.data.loggerData.note = `streamingService ${apiResponseCartRemove?.data?.loggerData.note}`;
            logger(apiResponseCartRemove?.data?.loggerData);
            yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: apiResponseCartRemove?.data?.errors[0]?.notifyMessage });
          }
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
          yield put({ type: 'ADDON_INVALIDCASE_ERROR', response: addonsInvalidError });
          hideLoader();
        }
      } catch (error) {
        hideLoader();
        if (error?.response) {
          errorDetails = true;
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
        }
      }
      break;

    case 'deviceSetup':
      try {
        showLoader();
        let setupInvalidCaseError = false;
        yield put({ type: 'SETUP_INVALIDCASE_ERROR', response: setupInvalidCaseError });
        yield put({ type: 'DEVICE_SETUP_ERROR', response: errorDetails });

        const apiResponseData = yield call(Actions.getDeviceSetup, data);
        if (apiResponseData && apiResponseData.status === 200 && !apiResponseData.data.errors) {
          if (isExpressCheckout()) {
            yield call(Actions.getCartDetails, { pageName: 'setup' });
          }
          if (!isExpressCheckout()) {
            yield put({ type: 'RESET_GET_CHECKOUT_DETAILS' });
          }
          showLoader();
          if (isAppointmentSetupEnabled() && !!payLoadObj && !payLoadObj?.noDatesAvailableCheck) {
            const apiResponse = yield call(deviceSetupActions.postPro, payLoadObj?.payloadRequestData);
            if (apiResponse && apiResponse?.data && !apiResponse?.data?.errors) {
              yield put({ type: Constants.POST_DATA_PRO_INSTALLATION_DEVICE_SETUP_SUCCESS, response: apiResponse.data });
              yield put({ type: 'SET_SAVE_5G_APPOINTMENT_STATUS', value: true });
              console.log('apiResponseTest', apiResponse);
            } else {
              if (apiResponse?.data?.loggerData) apiResponse.data.loggerData.note = `updateProInstallation ${apiResponse?.data?.loggerData?.note}`;
              logger(apiResponse?.data?.loggerData);
              yield put({
                type: 'CEF_APPOINTMENT_ERROR',
                response: false,
                errorMessage: apiResponse?.data?.errors[0]?.notifyMessage,
              });
              yield put({ type: 'SET_SAVE_5G_APPOINTMENT_STATUS', value: false });
            }
          }
          if (enablePegaProcessSteps() && apiResponseData?.data?.serviceBody?.serviceResponse?.context?.contextInfo?.processStep) {
            const processStep = GetProcessStepPages(apiResponseData?.data?.serviceBody?.serviceResponse?.context?.contextInfo?.processStep);
            const availablePaths = apiResponseData?.data?.serviceBody?.serviceResponse?.context?.contextInfo?.availablePaths?.[0]?.path;
            if (processStep && processStep !== '') {
              yield put({ type: 'NEXT_PROCESS_STEP', value: processStep, ...(isJTFlowFromNGDCart() && { availablePaths } ) });
            }
            const currentPageName = GetCurrentPageName();
            if (currentPageName) {
              yield put({ type: 'PREVIOUS_PROCESS_STEP', value: currentPageName });
            }
            yield put({ type: 'UPDATED_SETUP_PROCESSSTEP', value: true });
          }
          yield put({ type: Constants.UPDATE_INSTALL_TYPE_SUUCESS });
          yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
          hideLoader();
        } else {
          if (
            apiResponseData &&
            ((apiResponseData?.data && apiResponseData?.data?.errors) || (apiResponseData?.request && apiResponseData?.request?.status !== 200))
          ) {
            if (apiResponseData?.status === 400 && checkInvalidCaseCartError(apiResponseData?.data?.errors)) {
              setupInvalidCaseError = true;
            } else {
              errorDetails = true;
            }

            if (apiResponseData?.data?.loggerData) apiResponseData.data.loggerData.note = `deviceSetup ${apiResponseData?.data?.loggerData.note}`;
            logger(apiResponseData?.data?.loggerData);
            yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: apiResponseData?.data?.errors[0]?.notifyMessage });
          }
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: 'SETUP_INVALIDCASE_ERROR', response: setupInvalidCaseError });
          yield put({ type: 'DEVICE_SETUP_ERROR', response: errorDetails });
          hideLoader();
        }
      } catch (errorDeviceSetup) {
        hideLoader();
        if (errorDeviceSetup?.response) {
          errorDetails = true;
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
        }
      }
      break;

    case 'deviceSetupMovers':
      try {
        showLoader();
        const apiResponse = yield call(Actions.getDeviceSetup, data);
        if (apiResponse && apiResponse.status === 200 && !apiResponse.data.errors) {
          showLoader();
          yield call(Actions.getCartDetails, { pageName: data });
          yield put({ type: Constants.UPDATE_INSTALL_TYPE_SUUCESS_MV });
          yield put({ type: Constants.ASYNC_FETCH_SUCCESS_MV });
          hideLoader();
        } else {
          if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
            errorDetails = true;
            if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `deviceSetupMovers ${apiResponse?.data?.loggerData.note}`;
            logger(apiResponse?.data?.loggerData);
            yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
          }
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          hideLoader();
        }
      } catch (error) {
        hideLoader();
        if (error?.response) {
          errorDetails = true;
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
        }
      }
      break;

    case 'vzProtectHome':
      yield put({ type: Constants.ASYNC_FETCH });
      try {
        showLoader();
        const apiResponseVzProtectHome = yield call(Actions.getVzProtectHome, data);
        if (apiResponseVzProtectHome && apiResponseVzProtectHome.status === 200 && !apiResponseVzProtectHome.data.errors) {
          if (updateType === 'addToCart') {
            oddOnListArr.push('vzProtectHome');
          }
          if (updateType === 'removeFromCart') {
            oddOnListArr = removeOneDuplicate(oddOnList, 'vzProtectHome');
          }
          store.dispatch({ type: 'SET_ADDONS', oddOnListArr });
          showLoader();
          yield call(Actions.getCartDetails, { pageName }); // TODO: Need to check page name

          hideLoader();
        } else {
          if (
            apiResponseVzProtectHome &&
            ((apiResponseVzProtectHome.data && apiResponseVzProtectHome.data.errors) ||
              (apiResponseVzProtectHome.request && apiResponseVzProtectHome.request.status !== 200))
          ) {
            if (apiResponseVzProtectHome?.status === 400 && checkInvalidCaseCartError(apiResponseVzProtectHome.data.errors)) {
              cartInvalidError = true;
              addonsInvalidError = true;
            } else {
              errorDetails = true;
            }

            if (apiResponseVzProtectHome.data.loggerData)
              apiResponseVzProtectHome.data.loggerData.note = `vzProtectHome ${apiResponseVzProtectHome?.data?.loggerData.note}`;
            logger(apiResponseVzProtectHome?.data?.loggerData);
            hideLoader();
            yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: apiResponseVzProtectHome?.data?.errors[0]?.notifyMessage });
          }
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
          yield put({ type: 'ADDON_INVALIDCASE_ERROR', response: addonsInvalidError });
          yield put(notificationActions.showErrorNotification(notifyErrorMessage));
          hideLoader();
        }
      } catch (error) {
        hideLoader();
        if (error?.response) {
          errorDetails = true;
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
        }
      }
      yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
      break;

    case 'whwServices':
      yield put({ type: Constants.ASYNC_FETCH });
      try {
        showLoader();
        const apiResponseWHW = yield call(Actions.getWHWPlan, data);
        let whwFlowResponse = apiResponseWHW;
        let whwFailedApi = 'getWHWPlan';
        let beaconAccessoryFailed = false;
        let whwFlowSuccess =
          apiResponseWHW && apiResponseWHW.status === 200 && !apiResponseWHW.data?.errors;

        if (isBeaconUpgradeFlow(data) && whwFlowSuccess) {
          const accessoryPayload = getBeaconUpgradeAccessoryPayload(data);
          if (accessoryPayload) {
            const apiResponseUpgradeAccessory = yield call(Actions.getAddAccessories, accessoryPayload);
            const upgradeAccessorySuccess =
              apiResponseUpgradeAccessory &&
              apiResponseUpgradeAccessory.status === 200 &&
              !apiResponseUpgradeAccessory.data?.errors;

            if (!upgradeAccessorySuccess) {
              whwFlowSuccess = false;
              whwFlowResponse = apiResponseUpgradeAccessory;
              whwFailedApi = 'getAddAccessories';
              beaconAccessoryFailed = true;
            }
          }
        }

        if (whwFlowSuccess) {
          if (updateType === 'addToCart') {
            oddOnListArr.push('getWHWPlan');
          }
          if (updateType === 'removeFromCart') {
            oddOnListArr = removeOneDuplicate(oddOnList, 'getWHWPlan');
          }
          store.dispatch({ type: 'SET_ADDONS', oddOnListArr });
          store.dispatch({ type: 'ADDON_FEATURE_SUCCESS', value: true });
          store.dispatch({ type: 'SELECTED_WHW_CATEGORY', value: data?.selectedCategory });
          showLoader();
          if (!(isFuncComp() === true)) {
            yield call(Actions.getCartDetails, data);
          } else if (isFuncComp()) {
            const dataPayLoad = {
              paymentOptions: true,
              cart: true,
              shippingOptions: true,
            };
            yield call(getCheckoutActions.getCheckoutDetailsCall, dataPayLoad);
          }

          yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
          hideLoader();
          if (data && data?.addWHWPlan?.pageName === 'displayShippingOptions') {
            store.dispatch({ type: 'REMOVED_WHWPLUS' });
          }
        } else {
          if (
            whwFlowResponse &&
            ((whwFlowResponse.data && whwFlowResponse.data.errors) ||
              (whwFlowResponse.request && whwFlowResponse.request.status !== 200))
          ) {
            if (whwFlowResponse?.status === 400 && checkInvalidCaseCartError(whwFlowResponse.data.errors)) {
              cartInvalidError = true;
              addonsInvalidError = true;
            } else {
              errorDetails = true;
            }

            if (whwFlowResponse.data?.loggerData) {
              whwFlowResponse.data.loggerData.note = `${whwFailedApi} ${whwFlowResponse?.data?.loggerData.note}`;
              logger(whwFlowResponse?.data?.loggerData);
            }
            hideLoader();
            yield put({
              type: Constants.CEF_CART_ERROR,
              response: true,
              errorMessage: whwFlowResponse?.data?.errors?.[0]?.notifyMessage,
            });
          } else if (beaconAccessoryFailed) {
            errorDetails = true;
            hideLoader();
            yield put({
              type: Constants.CEF_CART_ERROR,
              response: true,
              errorMessage: Constants.DEFAULT_ERROR_MESSAGE,
            });
          }
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
          yield put({ type: 'ADDON_INVALIDCASE_ERROR', response: addonsInvalidError });
          yield put(notificationActions.showErrorNotification(notifyErrorMessage));
          if (data && data?.addWHWPlan?.pageName === 'displayShippingOptions') {
            store.dispatch({ type: 'REMOVE_WHWPLUS' });
          }
          store.dispatch({ type: 'ADDON_FEATURE_SUCCESS', value: false });
          hideLoader();
        }
      } catch (error) {
        hideLoader();
        if (error?.response) {
          errorDetails = true;
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
        }
      }
      yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
      break;

    case 'homePhoneService':
      try {
        const apiResponseHomePhoneService = yield call(Actions.getHomePhoneService, data);
        const { data: dataHomePhoneService, request, status = '' } = apiResponseHomePhoneService || {};

        if (status === 200 && !dataHomePhoneService.errors) {
          const assignMtnValue = store.getState() && store.getState().addons && store.getState().addons.assignMtnValue;
          yield call(addonsActions.assignNPANXXMTNHP, assignMtnValue.npanxx, assignMtnValue.ngp1);
          if (updateType === 'addToCart') {
            oddOnListArr.push('homePhoneService');
          } else if (updateType === 'removeFromCart') {
            oddOnListArr = removeOneDuplicate(oddOnList, 'homePhoneService');
          }
          store.dispatch({ type: 'SET_ADDONS', oddOnListArr });
          showLoader();
          yield call(Actions.getCartDetails, { pageName: data });
          yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
          hideLoader();
        } else {
          if (dataHomePhoneService?.errors || request?.status !== 200) {
            if (status === 400 && checkInvalidCaseCartError(dataHomePhoneService.errors)) {
              cartInvalidError = true;
              addonsInvalidError = true;
            } else {
              errorDetails = true;
            }

            if (dataHomePhoneService?.loggerData) {
              dataHomePhoneService.loggerData.note = `homePhoneService ${dataHomePhoneService.loggerData.note}`;
              logger(dataHomePhoneService.loggerData);
            }
            yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: dataHomePhoneService?.errors?.[0]?.notifyMessage });
          }
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
          yield put({ type: 'ADDON_INVALIDCASE_ERROR', response: addonsInvalidError });
          hideLoader();
        }
      } catch (errorHomePhoneService) {
        hideLoader();
        if (errorHomePhoneService?.response) {
          errorDetails = true;
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
        }
      }
      break;

    case 'removeHomePhone':
      try {
        const apiResponseRemoveHomePhone = yield call(Actions.removeHomePhone, data);
        const { data: dataRemoveHomePhone, request, status = '' } = apiResponseRemoveHomePhone || {};

        if (status === 200 && !dataRemoveHomePhone.errors) {
          if (updateType === 'addToCart') {
            oddOnListArr.push('homePhoneService');
          } else if (updateType === 'removeFromCart') {
            oddOnListArr = removeOneDuplicate(oddOnList, 'homePhoneService');
          }
          store.dispatch({ type: 'SET_ADDONS', oddOnListArr });
          showLoader();
          yield call(Actions.getCartDetails, { pageName: data });
          yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
          hideLoader();
        } else {
          if (dataRemoveHomePhone?.errors || request?.status !== 200) {
            if (status === 400 && checkInvalidCaseCartError(dataRemoveHomePhone.errors)) {
              cartInvalidError = true;
              addonsInvalidError = true;
            } else {
              errorDetails = true;
            }

            if (dataRemoveHomePhone?.loggerData) {
              dataRemoveHomePhone.loggerData.note = `removeHomePhone ${dataRemoveHomePhone.loggerData.note}`;
              logger(dataRemoveHomePhone.loggerData);
            }

            yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: dataRemoveHomePhone?.errors[0]?.notifyMessage });
          }
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
          yield put({ type: 'ADDON_INVALIDCASE_ERROR', response: addonsInvalidError });
          hideLoader();
        }
      } catch (error) {
        hideLoader();
        if (error?.response) {
          errorDetails = true;
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
        }
      }
      break;
    default:
      break;
  }
}

function* addRemoveAccessory({ data, actionType, oddOnList, updateType, pageName, cb }) {
  yield put({ type: EXPRESS_CHECKOUT_DETAILS_PREFETCH, response: 'RESET' });
  let errorDetails = false;
  let cartInvalidError = false;
  let addonsInvalidError = false;
  yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
  yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
  yield put({ type: 'ADDON_INVALIDCASE_ERROR', response: addonsInvalidError });
  yield put({ type: Constants.CEF_CART_ERROR, response: false, errorMessage: null });
  yield put({ type: 'ADD_ACCESSORY_REMOVE_LOADED', response: false });
  showLoader();

  const isCallBackNeeded = cb && typeof cb === 'function';

  switch (actionType) {
    case 'streamingDevice':
      try {
        showLoader();
        const apiResponseRemoveAccessories = yield call(Actions.getAddAccessories, data);
        const { data: dataStreamingDevice, request, status = '' } = apiResponseRemoveAccessories || {};

        if (dataStreamingDevice && !dataStreamingDevice.errors) {
          let oddOnListArr = oddOnList;
          if (updateType === 'addToCart') {
            oddOnListArr.push('streamingDevice');
          } else if (updateType === 'removeFromCart') {
            oddOnListArr = removeOneDuplicate(oddOnList, 'streamingDevice');
            store.dispatch({ type: 'ADD_ACCESSORY_REMOVE_LOADED', response: true });
          }
          store.dispatch({ type: 'SET_ADDONS', oddOnListArr });
          const { serviceHeader } = dataStreamingDevice;

          if (serviceHeader?.statusMsg === 'SUCCESS' || serviceHeader?.statusCode === '00') {
            try {
              showLoader();
              yield call(Actions.getCartDetails, { pageName, validCouponResponse: data });
              yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
              yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
              yield put({ type: 'ADDON_INVALIDCASE_ERROR', response: addonsInvalidError });
              hideLoader();
              if (isCallBackNeeded) {
                cb();
              }
            } catch (error) {
              hideLoader();
              if (error?.response) {
                errorDetails = true;
                yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
                yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
              }
            }
            yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
          }
        } else {
          if (dataStreamingDevice?.errors || request?.status !== 200) {
            if (status === 400 && checkInvalidCaseCartError(dataStreamingDevice.errors)) {
              cartInvalidError = true;
              addonsInvalidError = true;
            } else {
              errorDetails = true;
            }
            if (dataStreamingDevice.loggerData) {
              dataStreamingDevice.loggerData.note = `streamingDevice ${dataStreamingDevice?.loggerData.note}`;
              logger(dataStreamingDevice.loggerData);
            }

            hideLoader();
            yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: data?.errors?.[0]?.notifyMessage });
          }
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
          yield put({ type: 'ADDON_INVALIDCASE_ERROR', response: addonsInvalidError });
        }
      } catch (error) {
        hideLoader();
        if (error?.response) {
          errorDetails = true;
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
        }
      }
      break;
    case 'whwServices':
      try {
        showLoader();
        const apiResponseRemoveWhwAccessories = yield call(Actions.getAddAccessories, data);
        const { data: dataWhwServices, request, status = '' } = apiResponseRemoveWhwAccessories || {};

        if (dataWhwServices && !dataWhwServices.errors) {
          let oddOnListArr = oddOnList;
          if (updateType === 'addToCart') {
            oddOnListArr.push('whwServices');
          } else if (updateType === 'removeFromCart') {
            oddOnListArr = removeOneDuplicate(oddOnList, 'whwServices');
          }
          store.dispatch({ type: 'SET_ADDONS', oddOnListArr });
          const { serviceHeader } = dataWhwServices;

          if (
            serviceHeader &&
            ((serviceHeader.statusMsg && serviceHeader.statusMsg === 'SUCCESS') || (serviceHeader.statusCode && serviceHeader.statusCode === '00'))
          ) {
            try {
              showLoader();
              yield call(Actions.getCartDetails, { pageName, validCouponResponse: data });

              yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
              yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
              yield put({ type: 'ADDON_INVALIDCASE_ERROR', response: addonsInvalidError });
              hideLoader();
            } catch (error) {
              hideLoader();
              if (error?.response) {
                errorDetails = true;
                yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
                yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
              }
            }
            yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
          }
        } else {
          if (dataWhwServices?.errors || request?.status !== 200) {
            if (status === 400 && checkInvalidCaseCartError(dataWhwServices.errors)) {
              cartInvalidError = true;
              addonsInvalidError = true;
            } else {
              errorDetails = true;
            }
            if (dataWhwServices?.loggerData) {
              dataWhwServices.loggerData.note = `whwServices ${dataWhwServices.loggerData.note}`;
              logger(dataWhwServices.loggerData);
            }

            hideLoader();
            yield put({
              type: Constants.CEF_CART_ERROR,
              response: true,
              errorMessage: dataWhwServices?.errors[0]?.notifyMessage,
            });
          }
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
          yield put({ type: 'ADDON_INVALIDCASE_ERROR', response: addonsInvalidError });
        }
      } catch (error) {
        hideLoader();
        if (error?.response) {
          errorDetails = true;
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
        }
      }
      break;
    default:
      break;
  }
}

function* resetProceedFlow() {
  yield put({ type: Constants.PROCEED_TO_NEXT, response: false });
}
export function invokeCallback(callback, data) {
  if (callback && typeof callback === 'function') {
    callback(data);
  }
}
function* getReviewOrderApi({ data }) {
  yield put({ type: Constants.ASYNC_FETCH });
  showLoader();
  yield put(notificationActions.hideNotification());
  let errorDetails = false;
  let cartInvalidError = false;
  let proceedToNext = false;
  yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
  yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
  yield put({ type: Constants.CEF_CART_ERROR, response: false, errorMessage: null });
  yield put({ type: Constants.VALIDATE_ORDER_FAILED, response: false });
  try {
    const apiResponseReviewOrder = yield call(Actions.reviewOrderCall, data);
    if (apiResponseReviewOrder && apiResponseReviewOrder.status === 200 && !apiResponseReviewOrder.data.errors) {
      const validateOrder = apiResponseReviewOrder.data?.serviceBody?.serviceResponse?.context?.validateOrder || {};
      yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
      yield put({ type: Constants.UPDATE_VALIDATE_ORDER, response: validateOrder });
      const creditApprovalStatus = validateOrder?.orderDetails?.[0]?.creditApprovalStatus;
      if (creditApprovalStatus) {
        proceedToNext = true;
        if (creditApprovalStatus === 'AP') {
          setSession('approvalStatus', 'N');
        }
      }
      yield put({ type: Constants.PROCEED_TO_NEXT, response: proceedToNext });
      hideLoader();
      invokeCallback(data?.cb, validateOrder);
      if (isWHW() || isWWM()) {
        window.location.href = apiUrls().redirectShipping;
      }
    } else {
      hideLoader();
      yield put({ type: Constants.VALIDATE_ORDER_FAILED, response: true });
      if (
        apiResponseReviewOrder &&
        ((apiResponseReviewOrder.data && apiResponseReviewOrder.data.errors) ||
          (apiResponseReviewOrder.request && apiResponseReviewOrder.request.status !== 200))
      ) {
        if (apiResponseReviewOrder?.status === 400 && checkInvalidCaseCartError(apiResponseReviewOrder.data.errors)) {
          cartInvalidError = true;
        } else {
          errorDetails = true;
        }
        if (apiResponseReviewOrder?.data?.loggerData) {
          apiResponseReviewOrder.data.loggerData.note = `streamingDevice ${apiResponseReviewOrder.data.loggerData.note}`;
          logger(apiResponseReviewOrder.data.loggerData);
        }

        yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: apiResponseReviewOrder?.data?.errors?.[0]?.notifyMessage });
      }
      yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails, notifyErrorMsg: apiResponseReviewOrder?.data?.errors?.[0]?.message });
      yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
    }
  } catch (error) {
    hideLoader();
    yield put({ type: Constants.VALIDATE_ORDER_FAILED, response: true });
    if (error?.response) {
      errorDetails = true;
      yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
      yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
  }
}

function* ntasAddressCall(data) {
  const addressData = data.data;

  // TO DO - need to update the 3 regex
  const street1 = addressData.replace(/[-_/\\&:';"^$*+?,.()|[\]{}]/g, ' ');
  const street2 = street1.replace(/(^\s+)|(\s+$)/g, '');
  let street = street2.replace(/\s+/g, ' ');

  let errorDetails = false;
  const authToken = yield getAuthTokenforAddressFetch();
  if (authToken) {
    const ntasapiResponse = yield call(Actions.ntasAutoFillSearch, { request: addressData, authToken });
    if (ntasapiResponse && ntasapiResponse.status === 200 && !ntasapiResponse.data.errors) {
      yield put({ type: Constants.FETCH_AUTOFILL_ADDRESS_SUCCESS, apiResponse: ntasapiResponse.data });
      if (ntasapiResponse?.data?.addresses?.length > 0) {
        yield put({ type: Constants.IS_EMPTY_ADDRESS, value: false });
      } else {
        yield put({ type: Constants.IS_EMPTY_ADDRESS, value: true });
        const regex = /^(.).*\1$/;
        const streetTrim = street.trim();
        if (streetTrim.length > 10 && regex.test(streetTrim)) {
          street = streetTrim.slice(0, -1);
          const ntasapiCallResponse = yield call(Actions.ntasAutoFillSearch, { request: addressData, authToken });
          if (ntasapiCallResponse && ntasapiCallResponse.status === 200 && !ntasapiCallResponse.data.errors) {
            yield put({ type: Constants.FETCH_AUTOFILL_ADDRESS_SUCCESS, apiResponse: ntasapiCallResponse.data });
            if (ntasapiResponse?.data?.addresses?.length > 0) {
              yield put({ type: Constants.IS_EMPTY_ADDRESS, value: false });
            } else {
              yield put({ type: Constants.IS_EMPTY_ADDRESS, value: true });
            }
          }
        }
      }
    }
  } else {
    errorDetails = true;
    yield put({ type: Constants.IS_EMPTY_ADDRESS, value: true });
    yield put({ type: Constants.FETCH_AUTOFILL_ADDRESS_FAILURE, errorDetails });
  }
}

function* getAuthTokenforAddressFetch() {
  try {
    const apiResponse = yield call(Actions.getAuthorizationTokenAPICall);
    if (apiResponse.data && !apiResponse.data.errors) {
      return apiResponse.data.access_token;
    }
    console.log('token generation failed');
    if (apiResponse?.data?.loggerData) {
      apiResponse.data.loggerData.note = `issue in token genration ${apiResponse.data.loggerData.note}`;
      logger(apiResponse.data.loggerData);
    }
  } catch (error) {
    // catch
  }
}

function* getAddressAutofill(data) {
  let errorDetails = false;
  try {
    const apiResponse = yield call(Actions.fetchAutoFillSearch, data.data);
    if (apiResponse && apiResponse.status === 200 && !apiResponse.data.errors) {
      yield put({ type: Constants.FETCH_AUTOFILL_ADDRESS_SUCCESS, apiResponse: apiResponse.data });
      if (apiResponse?.data?.addresses?.length > 0) {
        yield put({ type: Constants.IS_EMPTY_ADDRESS, value: false });
      } else {
        yield ntasAddressCall(data);
      }
    } else {
      yield put({ type: Constants.IS_EMPTY_ADDRESS, value: true });
      yield put({ type: Constants.FETCH_AUTOFILL_ADDRESS_FAILURE, errorDetails: true });
      yield ntasAddressCall(data);
      if (apiResponse?.data?.loggerData) {
        apiResponse.data.loggerData.note = `getAddressAutofill ${apiResponse.data.loggerData.note}`;
        logger(apiResponse.data.loggerData);
      }
    }
  } catch (error) {
    if (error?.response) {
      errorDetails = true;
      yield put({ type: Constants.IS_EMPTY_ADDRESS, value: true });
      yield put({ type: Constants.FETCH_AUTOFILL_ADDRESS_FAILURE, errorDetails });
    }
  }
}

function* getAddressAutofillUnit2(data) {
  let errorDetails = false;
  yield put({ type: Constants.FETCH_AUTOFILL_ADDRESS_UNIT_SUCCESS2, apiResponse: {} });
  try {
    const apiResponse = yield call(Actions.fetchUnitDetails, data);
    if (apiResponse && apiResponse.status === 200 && !apiResponse.data.errors) {
      yield put({ type: Constants.FETCH_AUTOFILL_ADDRESS_UNIT_SUCCESS2, apiResponse: apiResponse?.data });
    } else {
      yield put({ type: Constants.FETCH_AUTOFILL_ADDRESS_UNIT_FAILURE, errorDetails: true });
      if (apiResponse?.data?.loggerData) {
        apiResponse.data.loggerData.note = `getAddressAutofillUnit ${apiResponse.data.loggerData.note}`;
        logger(apiResponse.data.loggerData);
      }
    }
  } catch (error) {
    if (error?.response) {
      errorDetails = true;
      yield put({ type: Constants.FETCH_AUTOFILL_ADDRESS_UNIT_FAILURE, errorDetails });
    }
  }
}

function* get5GAppConfigURL(data) {
  let errorDetails = false;
  yield put({ type: Constants.FETCH_APPCONFIG_API_SUCCESS, apiResponse: {} });
  try {
    const apiResponse = yield call(Actions.get5GAppConfig, data.data);
    if (apiResponse && apiResponse.status === 200 && !apiResponse.data.errors) {
      yield put({ type: Constants.FETCH_APPCONFIG_API_SUCCESS, apiResponse: apiResponse?.data });
    }
  } catch (error) {
    hideLoader();
    if (error?.response) {
      errorDetails = true;
      yield put({ type: Constants.SHOW_APPCONFIG_API_FAILURE, errorDetails });
    }
  }
}

function* getAddressAutofillUnit(data) {
  let errorDetails = false;
  yield put({ type: Constants.FETCH_AUTOFILL_ADDRESS_UNIT_SUCCESS, apiResponse: {} });
  try {
    const apiResponse = yield call(Actions.fetchAutoFillSearchUnit, data.data);
    if (apiResponse && apiResponse.status === 200 && !apiResponse.data.errors) {
      yield put({ type: Constants.FETCH_AUTOFILL_ADDRESS_UNIT_SUCCESS, apiResponse: apiResponse?.data });
    } else {
      yield put({ type: Constants.FETCH_AUTOFILL_ADDRESS_UNIT_FAILURE, errorDetails: true });
      if (apiResponse?.data?.loggerData) {
        apiResponse.data.loggerData.note = `getAddressAutofillUnit ${apiResponse.data.loggerData.note}`;
        logger(apiResponse.data.loggerData);
      }
    }
  } catch (error) {
    if (error?.response) {
      errorDetails = true;
      yield put({ type: Constants.FETCH_AUTOFILL_ADDRESS_UNIT_FAILURE, errorDetails });
    }
  }
}

function getCheckOutDetailsAndSMSEnabledPrefetch() {
  store.dispatch(getCheckOutDetails({ paymentOptions: true, cart: true, shippingOptions: true, isApiPrefetch: true }));
  store.dispatch(fetchSMSEnabledDevices({ isApiPrefetch: true }));
  window.isPrefetchGetCheckoutAndSms = true;
}

function* handlePrefetchUpdate(prefetchValidateCart, status) {
  if (prefetchValidateCart === 'cart' && status === 'COMPLETED') {
    yield put({ type: Constants.PREFETCH_SETUP_STATUS, response: status });
  }
  if (prefetchValidateCart === 'cart' && status === 'FAILED') {
    yield put({ type: Constants.PREFETCH_SETUP_STATUS, response: status });
  }
}

function* getValidateCartApi({ data, pageName, validCouponResponse, prefetchValidateCart = '' }) {
  let errorDetails = false;
  // let cartValidationError = '';
  yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
  yield put({ type: Constants.CEF_CART_ERROR, response: false, errorMessage: null });
  const isLoggedin = getAPPID() === 'AAL';
  const isExistingCase = getSession('ExistingCase');
  const showModal = isLoggedin && isExistingCase === 'true';
  const notifyErrorMessage = data;
  yield put({ type: Constants.ASYNC_FETCH });
  handleShowLoader(prefetchValidateCart);

  yield put(notificationActions.hideNotification());
  yield put({ type: Constants.ENABLE_CNT_BTN, response: false });
  let skipRetrieveCart = false;
  const validateCartEnabled = pageName === 'cart' && window.vzFlags.isValidateCartCall;
  if (pageName === 'CheckOut') {
    skipRetrieveCart = true;
  }
  yield put({ type: 'API_LOADED', response: false });
  try {
    if (showModal || validateCartEnabled) {
      const getCartesponse = yield call(Actions.getCartDetailsForValidateCart, { pageName });
      if (getCartesponse && getCartesponse.status === 200 && getCartesponse.data && !getCartesponse.data.errors) {
        yield call(handlePrefetchUpdate, prefetchValidateCart, 'COMPLETED');
        yield put({ type: 'API_LOADED', response: true });
        if (getCartesponse?.data?.cartValidationErrors?.length > 0 && validateCartEnabled && !showModal) {
          getCartesponse.data.cartValidationErrors.map((list) => {
            if (list?.errorLevel && list.errorLevel === 'Blocker' && list.errorCode && (list.errorCode === '1023' || list.errorCode === '1022')) {
              errorDetails = true;
              // cartValidationError = `cartValidationErrors-${list.errorLevel},${list.errorCode}`;
              const blockerError = {
                errorCode: list && list.errorCode,
                value: true,
              };
              store.dispatch({ type: 'REDIRECT_TO_PLANS', response: blockerError });
            }
          });
        }
        if (errorDetails) {
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.VALIDATECART_RESPONSE, response: 'Failure' });
          yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: 'Blocker' });
          if (getCartesponse.data.loggerData) getCartesponse.data.loggerData.note = `getValidateCartApi ${getCartesponse?.data?.loggerData.note}`;
          logger(getCartesponse?.data?.loggerData);
          yield put({ type: Constants.ENABLE_CNT_BTN, response: false });
          handleHideLoader(prefetchValidateCart);
        } else {
          yield put({ type: Constants.ENABLE_CNT_BTN, response: true });
          yield put({ type: Constants.GET_CART_SUCCESS, response: getCartesponse.data });
          const { unifiedNbsData, orderDetailsView, featureFlags } = getCartesponse?.data || {};
          if (isLoggedin && unifiedNbsData) {
            yield put({ type: 'NBS_CART_ID_UPDATE', response: unifiedNbsData, fFlag: !!featureFlags?.unifiedNbsFFlag });
          }
          const isSelfSetupOpted = orderDetailsView?.installType === 'Self SetUp';
          if (prefetchGetCheckoutAndSmsEnabled() && getAPPID() === 'AAL' && isSelfSetupOpted) {
            getCheckOutDetailsAndSMSEnabledPrefetch();
          }
          hideLoader();
        }
      } else {
        if (getCartesponse.data && getCartesponse.data.errors) {
          yield put({ type: Constants.GET_CART_SUCCESS, response: getCartesponse.data });
          errorDetails = true;
          if (getCartesponse.data.loggerData) getCartesponse.data.loggerData.note = `getValidateCartApi ${getCartesponse?.data?.loggerData.note}`;
          logger(getCartesponse?.data?.loggerData);
          yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: getCartesponse?.data?.errors[0]?.notifyMessage });
        }
        yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
        yield call(handlePrefetchUpdate, prefetchValidateCart, 'FAILED');
        hideLoader();
      }
    } else {
      const apiResponseValidateCart = yield call(Actions.validateCartCall, data);
      if (apiResponseValidateCart && apiResponseValidateCart.status === 200 && apiResponseValidateCart.data && !apiResponseValidateCart.data.errors) {
        if (apiResponseValidateCart?.data?.data?.validateCartAndUpdate?.cartValidationErrors?.length > 0) {
          apiResponseValidateCart.data.data.validateCartAndUpdate.cartValidationErrors.map((list) => {
            if (list && list.errorLevel && list.errorLevel === 'Blocker' && list.errorCode && list.errorCode === '1023') {
              errorDetails = true;
              const blockerError = {
                errorCode: list?.errorCode,
                value: true,
              };
              store.dispatch({ type: 'REDIRECT_TO_PLANS', response: blockerError });
            }
          });
        }
        if (errorDetails) {
          yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
          yield put({ type: Constants.VALIDATECART_RESPONSE, response: 'Failure' });
          yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: 'Blocker' });
          if (apiResponseValidateCart?.data?.loggerData) {
            apiResponseValidateCart.data.loggerData.note = `getValidateCartApi ${apiResponseValidateCart.data.loggerData.note}`;
            logger(apiResponseValidateCart.data.loggerData);
          }

          yield put({ type: Constants.ENABLE_CNT_BTN, response: false });
          hideLoader();
        } else {
          yield put({ type: Constants.VALIDATECART_RESPONSE, response: 'Completed' });
          showLoader();
          if (!skipRetrieveCart) {
            const getCartesponse = yield call(Actions.getCartDetails, { pageName, validCouponResponse });
            yield put({ type: 'API_LOADED', response: true });
            if (getCartesponse && getCartesponse.status === 200 && getCartesponse.data && !getCartesponse.data.errors) {
              yield put({ type: Constants.GET_CART_SUCCESS, response: getCartesponse.data });
              hideLoader();
            } else {
              hideLoader();
              if (getCartesponse.data && getCartesponse.data.errors) {
                errorDetails = true;
                if (apiResponseValidateCart?.data?.loggerData) {
                  apiResponseValidateCart.data.loggerData.note = `getValidateCartApi ${apiResponseValidateCart.data.loggerData.note}`;
                  logger(apiResponseValidateCart.data.loggerData);
                }

                yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: getCartesponse?.data?.errors[0]?.notifyMessage });
              }
              yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
            }
            yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
          }
          hideLoader();
        }
      } else {
        hideLoader();
        if (apiResponseValidateCart.data && apiResponseValidateCart.data.errors) {
          errorDetails = true;
        }
        yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
        yield put({ type: Constants.VALIDATECART_RESPONSE, response: 'Failure' });
        yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: apiResponseValidateCart?.data?.errors[0]?.notifyMessage });
        const notifyMsg = apiResponseValidateCart?.data?.errors?.[0]?.message || notifyErrorMessage;
        yield put(notificationActions.showErrorNotification(notifyMsg));
        if (apiResponseValidateCart?.data?.loggerData) {
          apiResponseValidateCart.data.loggerData.note = `getValidateCartApi ${apiResponseValidateCart.data.loggerData.note}`;
          logger(apiResponseValidateCart.data.loggerData);
        }
      }
    }
  } catch (error) {
    hideLoader();
    if (error?.response) {
      errorDetails = true;
      yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
      yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
      yield call(handlePrefetchUpdate, prefetchValidateCart, 'FAILED');
    }
  }
}

function* saveCartApi({ data }) {
  let errorDetails = false;
  yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
  yield put({ type: Constants.ASYNC_FETCH });
  yield put({ type: Constants.CEF_CART_ERROR, response: false, errorMessage: null });
  showLoader();
  yield put(notificationActions.hideNotification());
  yield put({ type: Constants.UPDATE_SAVE_CART_SUCCESS, response: false });
  try {
    const apiResponseSaveCart = yield call(Actions.saveCart, data);
    if (apiResponseSaveCart && apiResponseSaveCart.status === 200 && !apiResponseSaveCart.data.errors) {
      yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
      yield put({ type: Constants.UPDATE_SAVE_CART_SUCCESS, response: true });
      yield put({type: 'DISPLAY_SAVE_CART_SUCCESS_SECTION', value: true});
      yield put({ type: 'SAVE_CART', data: false });
      updateToAEP(data);
      hideLoader();
    } else {
      if (
        apiResponseSaveCart &&
        ((apiResponseSaveCart.data && apiResponseSaveCart.data.errors) || (apiResponseSaveCart.request && apiResponseSaveCart.request.status !== 200))
      ) {
        errorDetails = true;
        if (apiResponseSaveCart.data.loggerData)
          apiResponseSaveCart.data.loggerData.note = `saveCartApi ${apiResponseSaveCart?.data?.loggerData.note}`;
        logger(apiResponseSaveCart?.data?.loggerData);
        yield put({ type: Constants.UPDATE_SAVE_CART_SUCCESS, response: false });
        yield put({ type: 'SHOW_SAVE_CART', data: false });
        yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: apiResponseSaveCart?.data?.errors[0]?.notifyMessage });
      }
      yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
      hideLoader();
    }
  } catch (error) {
    hideLoader();
    if (error?.response) {
      errorDetails = true;
      yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
      yield put({ type: Constants.UPDATE_SAVE_CART_SUCCESS, response: false });
      yield put({ type: 'SHOW_SAVE_CART', data: false });
      yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
  }
}

function* updateCartAAL({ data }) {
  let errorDetails = false;
  let cartInvalidError = false;
  yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
  yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
  yield put({ type: Constants.ASYNC_FETCH });
  yield put({ type: Constants.CEF_CART_ERROR, response: false, errorMessage: null });
  showLoader();
  yield put(notificationActions.hideNotification());
  try {
    const apiResponseUpdateCart = yield call(Actions.getUpdateCartAPI, data);
    yield put({ type: Constants.UPDATE_CART_API_SUCCESS, response: 'IN_PROGRESS' });
    if (apiResponseUpdateCart && apiResponseUpdateCart.status === 200 && !apiResponseUpdateCart.data.errors) {
      showLoader();
      yield put({ type: Constants.UPDATE_CART_API_SUCCESS, response: 'COMPLETED' });
      store.dispatch({ type: 'CLEAR_COUPON_VALUE' });
      yield put({ type: 'SHIPPING_ADDRESS_CHANGE', data: false });
      yield put({ type: 'SHIPPING_ADDRESS_RADIO_SELECTED', data: '' });
      yield call(setSession, 'cartExist', apiResponseUpdateCart?.data?.serviceBody?.serviceResponse?.context?.cartInfo?.cartExist);
      yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
      if (data.actionType === 'Resume') {
        showLoader();
        yield put({ type: 'UPDATE_CART_AAL_SUCCESS_FLAG', response: false });
        yield put({ type: 'GET_NPA_NXX_SUCCESS', response: '' });
        yield put({
          type: 'UPDATE_PROCESS_STEP',
          response: apiResponseUpdateCart?.data?.serviceBody?.serviceResponse?.context?.contextInfo?.processStep,
        });
        setTimeout(() => {
          hideLoader();
        }, 3000);
      } else if (data.actionType === 'WHWP2') {
        window.location.href = apiUrls().redirectAddons;
      } else {
        yield put({ type: 'UPDATE_CART_AAL_SUCCESS_FLAG', response: true });
        yield put({ type: 'GET_NPA_NXX_SUCCESS', response: '' });
      }
    } else {
      if (
        apiResponseUpdateCart &&
        ((apiResponseUpdateCart.data && apiResponseUpdateCart.data.errors) ||
          (apiResponseUpdateCart.request && apiResponseUpdateCart.request.status !== 200))
      ) {
        yield put({ type: Constants.UPDATE_CART_API_SUCCESS, response: 'COMPLETED' });
        if (apiResponseUpdateCart?.status === 400 && checkInvalidCaseCartError(apiResponseUpdateCart.data.errors)) {
          cartInvalidError = true;
        } else {
          errorDetails = true;
        }
        if (apiResponseUpdateCart?.data?.loggerData) {
          apiResponseUpdateCart.data.loggerData.note = `updateCartAAL ${apiResponseUpdateCart.data.loggerData.note}`;
          logger(apiResponseUpdateCart.data.loggerData);
        }

        yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: apiResponseUpdateCart?.data?.errors[0]?.notifyMessage });
        setTimeout(() => {
          hideLoader();
        }, 3000);
      }
      yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
      yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
    }
  } catch (error) {
    if (error?.response) {
      hideLoader();
      yield put({ type: Constants.UPDATE_CART_API_SUCCESS, response: 'COMPLETED' });
      errorDetails = true;
      yield put({ type: Constants.SHOW_CART_API_ERROR, errorDetails });
      yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
  }
}

function* abandonCartCall({ data }) {
  yield put({ type: Constants.ASYNC_FETCH });
  try {
    const apiResponse = yield call(Actions.abandonCartAPI, data);
    if (apiResponse && apiResponse.data && apiResponse.data.code === 200.02 && !apiResponse.data.errors) {
      yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
    } else if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
      if (apiResponse?.data?.loggerData) {
        apiResponse.data.loggerData.note = `abandonCartCall ${apiResponse.data.loggerData.note}`;
        logger(apiResponse.data.loggerData);
      }
    }
  } catch (error) {
    hideLoader();
  }
}

function* getShippingInfoData({ data, homePhone }) {
  let errorShipping = false;
  yield put({ type: Constants.ERR_OCCURED, errorShipping });
  yield put({ type: Constants.ASYNC_FETCH });
  showLoader();
  try {
    const apiResponse = yield call(shippingActions.getDetails, data);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      yield put({ type: Constants.GET_DETAILS_SHIPPING_API_SUCCESS, response: apiResponse.data });
      hideLoader();
      if (data === 'preOrderNSE') {
        let homePhoneAdded = false;
        const homePhoneResponse = homePhone?.cartDetailsJson?.dueTodayList?.filter(
          (item) => item.isHomePhone !== undefined && item.isHomePhone === true,
        );
        if (homePhoneResponse && homePhoneResponse.length > 0) {
          homePhoneAdded = true;
        }
        const apiResponse1 = yield call(
          shippingActions.updateShippingOptions,
          apiResponse?.data?.lines?.[0]?.shippingOptions?.[0],
          null,
          null,
          homePhoneAdded,
        );
        if (apiResponse1 && apiResponse1.data && !apiResponse1.data.errors) {
          if (
            apiResponse1.data.serviceHeader &&
            ((apiResponse1.data.serviceHeader.statusMsg && apiResponse1.data.serviceHeader.statusMsg === 'SUCCESS') ||
              (apiResponse1.data.serviceHeader.statusCode && apiResponse1.data.serviceHeader.statusCode === '00'))
          ) {
            yield call(Actions.getCartDetails, { pageName: data });

            yield put({ type: Constants.POST_SHIPPINGOPTION_SUCCESS, response: apiResponse1.data });
            hideLoader();
          } else {
            hideLoader();
          }
        }
      }
    } else {
      if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
        errorShipping = true;
        if (apiResponse?.data?.loggerData) {
          apiResponse.data.loggerData.note = `getShippingInfoData ${apiResponse.data.loggerData.note}`;
          logger(apiResponse.data.loggerData);
        }

        hideLoader();
      }
      yield put({ type: Constants.ERR_OCCURED, errorShipping });

      yield put({
        type: 'UPDATE_SAVE_SELECTED_OPTION',
        data: apiResponse.data.lines[0].shippingOptions.filter((item) => item.addedShippingOptionId === 'true'),
      });
    }
  } catch (error) {
    if (error && error.response) {
      errorShipping = true;
      yield put({ type: Constants.ERR_OCCURED, errorShipping });
    }
    if (error) {
      hideLoader();
    }
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* updateProcesStepCart() {
  let cartInvalidError = false;
  yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
  yield put({ type: Constants.ASYNC_FETCH });
  yield put({ type: Constants.CEF_CART_ERROR, response: false, errorMessage: null });
  try {
    const apiResponse = yield call(Actions.updateProcessStepCartApi);
    if (apiResponse && apiResponse.data && apiResponse.data.errors) {
      if (apiResponse?.status === 400 && checkInvalidCaseCartError(apiResponse.data.errors)) {
        cartInvalidError = true;
        yield put({ type: Constants.CART_INVALIDCASE_ERROR, response: cartInvalidError });
        yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
      }
      if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `updateProcesStepCart ${apiResponse?.data?.loggerData.note}`;
      logger(apiResponse?.data?.loggerData);
    }
  } catch (error) {
    if (error && error.message) {
      // catch block
    }
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

// Adding new saga for coupon code
function* isCouponValid({ data, prodRef }) {
  let errorCoupon = false;
  const isLoggedin = getAPPID() === 'AAL';
  showLoader();
  try {
    const apiResponse = yield call(Actions.isCouponValidAPI, data);
    if (
      apiResponse?.data?.serviceHeader &&
      (apiResponse.data?.serviceBody?.serviceResponse?.context?.cartInfo?.statusCode === 1 ||
        apiResponse.data?.serviceBody?.serviceResponse?.context?.cartInfo?.statusCode === '1')
    ) {
      yield call(Actions.getCartDetails, { pageName: data });

      yield put({ type: Constants.COUPIN_VALID_SUCCESS, response: apiResponse.data, apiFailed: false });
      yield put({ type: 'COUPON_CODE', response: data });
      hideLoader();
      if (isLoggedin) {
        yield put({ type: 'NBS_UPDATE', response: false });
      }
    } else {
      if (apiResponse && apiResponse.data && apiResponse.data.errors) {
        const planInfo = getProductRefData('couponCodeErrorMessages', 'couponCodeErrorMessages', prodRef);
        const errorCode = apiResponse?.data?.errors?.[0]?.id;
        const errorCodeText = planInfo?.[0]?.[errorCode];
        yield put({ type: Constants.COUPIN_VALID_SUCCESS, response: apiResponse.data, apiFailed: false });
        const obj = {
          name: 'APPLY PROMO ERROR',
          message: errorCodeText, // The same error text presented to the user
          id: errorCode, // (optional if there is an associated error code)
          error: true, // a flag to tell us there was an error
        };
        eventDispatcher('notify', obj);
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `isCouponValid ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);
        hideLoader();
      }
      if (apiResponse?.request && apiResponse?.request?.status !== 200) {
        yield put({ type: Constants.COUPIN_VALID_SUCCESS, response: apiResponse.data, apiFailed: true });
        const obj = {
          name: 'APPLY PROMO ERROR',
          message: 'API ERROR', // The same error text presented to the user
          // id: errorCode, // (optional if there is an associated error code)
          error: true, // a flag to tell us there was an error
        };
        eventDispatcher('notify', obj);
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `isCouponValid ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);
        hideLoader();
      }
    }
    hideLoader();
  } catch (error) {
    if (error && error.response) {
      errorCoupon = true;
      yield put({ type: Constants.ERR_OCCURED, errorCoupon });
    }
    if (error) {
      hideLoader();
    }
  }
}

/**
 * ACT145-79 - Mini Cart - Performance Upgrade
 */
function* getMiniCart({ data }) {
  let errorDetails = false;
  yield put({ type: Constants.RESET_MINI_CART_STATUS, errorDetails });
  const notifyErrorMessage = data;
  showLoader();
  yield put({ type: Constants.ASYNC_FETCH });
  yield put(notificationActions.hideNotification());
  try {
    showLoader();
    yield put({ type: 'UPDATE_API_STATUS', response: 'IN_PROGRESS' });
    const apiMiniCartDueResponse = yield call(Actions.getMiniCartData, { pageName: data });
    if (apiMiniCartDueResponse && apiMiniCartDueResponse.data && !apiMiniCartDueResponse.data.errors) {
      yield put({ type: Constants.GET_MINI_CART_SUCCESS, response: apiMiniCartDueResponse.data });
      yield put({ type: 'UPDATE_API_STATUS', response: 'COMPLETED' });
      hideLoader();
    } else {
      if (
        apiMiniCartDueResponse &&
        ((apiMiniCartDueResponse.data && apiMiniCartDueResponse.data.errors) ||
          (apiMiniCartDueResponse.request && apiMiniCartDueResponse.request.status !== 200))
      ) {
        errorDetails = true;
        if (apiMiniCartDueResponse?.data?.errors) {
          if (apiMiniCartDueResponse.data.loggerData)
            apiMiniCartDueResponse.data.loggerData.note = `getMiniCartData ${apiMiniCartDueResponse?.data?.loggerData.note}`;
          logger(apiMiniCartDueResponse?.data?.loggerData);
        }
        hideLoader();
        yield put({ type: 'UPDATE_API_STATUS', response: 'FAILED' });
      }
      yield put({ type: Constants.GET_MINI_CART_ERROR, errorDetails });
      yield put(notificationActions.showErrorNotification(notifyErrorMessage));
    }
  } catch (error) {
    hideLoader();
    yield put({ type: 'UPDATE_API_STATUS', response: 'FAILED' });
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* checkoutDetails() {
  let errorDetails = false;
  try {
    showLoader();
    yield put({ type: Constants.CHECKOUT_DETAILS_SUCCESS, response: true });
    const apiResponse = yield call(Actions.getCheckoutDetails);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      hideLoader();
      yield put({ type: Constants.CHECKOUT_DETAILS_RESPONSE, response: apiResponse.data });
      yield put({ type: Constants.CHECKOUT_DETAILS_SUCCESS, response: true });
    } else {
      if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
        hideLoader();
        errorDetails = true;
        if (apiResponse?.data?.errors) {
          logger(apiResponse?.data?.errors);
        }
        yield put({ type: Constants.CHECKOUT_DETAILS_SUCCESS, response: false });
      }
      yield put({ type: Constants.CHECKOUT_DETAILS_ERROR, errorDetails });
      yield put(notificationActions.showErrorNotification(apiResponse?.data?.errors?.[0]?.message));
      if (apiResponse && apiResponse.request && apiResponse.request.status === 200) {
        yield put({ type: Constants.CHECKOUT_DETAILS_SUCCESS, response: true });
      }
    }
  } catch (error) {
    if (error && error.message) {
      hideLoader();
    }
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

export function* updateBarcode({ nbxOfferId }) {
  const BarCode = getSession('barCodeId') || '';
  showLoader();
  try {
    if (BarCode) {
      yield call(Actions.updateBarCodeAPI, nbxOfferId, BarCode);
      hideLoader();
    }
  } catch (error) {
    hideLoader();
  }
}
function handleError(cb, apiResponse, skipImmeditateResponse) {
  if (apiResponse?.data?.errors[0].id === Constants.OFFER_ALREADY_APPLIED_ERROR_ID) {
    cb(Constants.BARCODE_ALREADY_APPLIED);
    if (skipImmeditateResponse) {
      throw Error;
    }
  } else {
    throw Error;
  }
}
function* catchAbandonDiscount(cb, skipImmeditateResponse, apiData) {
  cb('UPDATE_PROMOCODE_FAILED');
  if (skipImmeditateResponse) {
    logger(apiData?.data?.loggerData);
    yield put({ type: 'BAR_CODE_OFFER_APPLIED_RESPONSE' });
  }
  yield put({ type: Constants.UPDATE_PROMOCODE_FAILED, response: true });
  yield put({ type: Constants.CEF_CART_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
}

function* handleGiftCartRemoval() {
  let giftCardAccessoryRemovalNeeded;
  if (isExpressCheckoutFLow()) {
    const getExpressCheckoutRequest = {
      paymentOptions: true,
      cart: true,
      shippingOptions: true,
      customerAgreements: true,
    };

    giftCardAccessoryRemovalNeeded = yield put({ type: 'GET_EXPRESS_CHECKOUT_DETAILS', data: getExpressCheckoutRequest });
  } else {
    giftCardAccessoryRemovalNeeded = yield call(Actions.getCartDetails, { pageName: '', FROM: 'ABANDON_CART_SUCCESS' });
  }
  return giftCardAccessoryRemovalNeeded;
}

function* applyAbandonDiscountOffer({ nbxOfferId, cb = () => {}, skipImmeditateResponse = false, extraParams = {} }) {
  showLoader();
  let apiData = {};
  try {
    const apiResponse = yield call(Actions.updateBarCodeAPI, nbxOfferId, undefined, extraParams);
    apiData = apiResponse;
    const apiResponseData =
      apiResponse?.data?.serviceBody?.serviceResponse?.context &&
      apiResponse?.data?.serviceBody?.serviceResponse?.context?.cartInfo?.statusMsg !== 'INVALID BARCODE';
    if (apiResponseData) {
      const responseData = apiResponse?.data?.validateCartResponse?.data?.validateCartAndUpdate?.orderDetails?.cartTotalDiscounts;
      yield put({ type: 'BAR_CODE_OFFER_APPLIED_RESPONSE', response: responseData });
      if (skipImmeditateResponse) {
        return;
      }
      const giftCardAccessoryRemovalNeeded = yield call(handleGiftCartRemoval);
      const isNonExpressCheckoutWithGift = giftCardAccessoryRemovalNeeded && !isExpressCheckoutFLow();
      if (isNonExpressCheckoutWithGift) {
        throw Error;
      } else {
        cb('SUCCESSFULLY_APPLIED');
        const pageName = getPageName();
        if(pageName === "progressiveplans" && isMiniCartFooterEnabled() ){
          yield put(Actions.getCartDataFromApi());
        }
        yield put({ type: 'INVOKE_TAGGING' });
        // TO DO - temp fix for resume - need to move this to pega process step
        // yield put({ type: Constants.UPDATE_PROCESS_STEP_CART });

        if (getAPPID() === 'AAL') {
          yield put({ type: 'NBS_UPDATE', response: false });
        }
      }
    } else {
      handleError(cb, apiResponse, skipImmeditateResponse);
    }
  } catch (error) {
    yield call(catchAbandonDiscount, cb, skipImmeditateResponse, apiData);
  }
  hideLoader();
}

function* nbxOfferRecommendations({ pageContext = '', hideOfferLoader = false, pzaiflag = false, errorDispatch = false, inCartPage}) {
  if (!hideOfferLoader) {
    showLoader();
  }
  try {
    const apiResponse = yield call(Actions.nbxOfferRecommendationsAPI, pageContext, inCartPage);
    if (apiResponse?.data?.response) {
        const eligible = apiResponse?.data?.response?.barCodeOffer?.offerEligible;
        const predictScore = eligible?  apiResponse?.data?.response?.barCodeOffer?.feedback?.predictScore : '';
        const IdleTimeValue = eligible? apiResponse?.data?.response?.barCodeOffer?.feedback?.idleTimeSec: '';
        const suffixMap = {
          FWA_Plans: 'upsell',
          FWA_ShoppingCart: 'sweetner',
        };
        const suffix = suffixMap[pageContext];
        eventDispatcher('sendData', {
          name: 'Notification',
          svars: {
            evar221: eligible ? `${suffix}_gc_q` : `${suffix}_gc_nq`,
            ...(pzaiflag && eligible && {evar155: `${predictScore}|${IdleTimeValue}`}),
          },
        });
      yield put({ type: 'UPDATE_NBX_OFFER_RECOMMENDATION', response: apiResponse.data });
      yield put({ type: 'GIFT_CARD_NBX_OFFER_RECOMMENDATION', response: apiResponse.data });
      yield put({ type: 'UPDATE_NBX_OFFER_RECOMMENDATION_EC', response: apiResponse.data });
    } else {
      throw Error;
    }
  } catch (error) {
    if (errorDispatch) {
      yield put({ type: 'UPDATE_NBX_OFFER_RECOMMENDATION' });
    }
    console.debug('nbx offer recommendation error:', error);
  }
  hideLoader();
}

function getNbxPostData({ offerDetails, dispositionOptionId, offerDismiss }) {
  const datenow = new Date();
  const uuid = `ubId-${uuidv4()}`;
  const dateTimeString = `${datenow.getUTCFullYear()}-${(datenow.getUTCMonth() + 1).toString().padStart(2, '0')}-${datenow.getUTCDate().toString().padStart(2, '0')} ${datenow.getUTCHours().toString().padStart(2, '0')}:${datenow.getUTCMinutes().toString().padStart(2, '0')}:${datenow.getUTCSeconds().toString().padStart(2, '0')} GMT`;
  return {
    service: {
      serviceHeader: {
        clientId: 'VZW-DOTCOM',
        serviceName: 'NBX',
        clientSessionId: uuid,
        clientTransactionId: uuid,
        e2eRequestId: uuid,
        timestamp: dateTimeString,
      },
      serviceBody: {
        serviceRequest: {
          contextInfo: {
            offerDismiss: offerDismiss || false,
            callReason: 'Recommendation',
            category: '5GRouter',
            pageContext: 'FWA_ShoppingCart',
            subServiceName: 'CaptureResponse',
            sessionId: offerDetails?.feedback?.feedbackSessionId || '',
          },
          customerInfo: {
            mtn: '0000000000',
            accountNo: '0000000000-00001',
          },
          customerResponse: {
            responseList: [
              {
                rank: offerDetails?.feedback?.rank || '',
                propositionId: offerDetails?.feedback?.propositionId || '',
                externalId: offerDetails?.feedback?.externalId || '',
                dispositionOptionId: dispositionOptionId || '',
                soiEngagementId: offerDetails?.feedback?.soiEngagementId,
                fulFillmentCode: offerDetails?.feedback?.fulFillmentCode || '',
                tacticLocation: offerDetails?.feedback?.tacticLocation || '',
                ctaReference: offerDetails?.feedback?.ctaReference || '',
                timeStamp: dateTimeString,
                dynamicAttrList: [
                  {
                    attrId: offerDetails?.feedback?.dynamicAttrList?.[0]?.attrId || '',
                    value: '',
                  },
                ],
              },
            ],
          },
        },
      },
    },
  };
}

function* submitNBXFeedback({ payload }) {
  try {
    const postData = yield call(getNbxPostData, payload);
    const apiResponse = yield call(Actions.submitNBXFeedbackAPI, postData);
    if (apiResponse?.data?.service?.serviceBody?.serviceResponse) {
      yield put({ type: Constants.NBX_FEEDBACK_RESPONSE, response: apiResponse.data });
      const nbxRes = apiResponse?.data?.service?.serviceBody?.serviceResponse.featureFlags
      const currentPageName = getPageName();
      if (payload?.offerDismiss && currentPageName === PROGRESSIVE_PLANS_PAGE) {
        const floatingOfferNSEFFlag = nbxRes?.giftCardOfferNSEFFlag;
        const floatingOfferAALFFlag = nbxRes?.giftCardOfferAALFFlag;
        const giftCardOfferFFlag = isLoggedIn() ? floatingOfferAALFFlag : floatingOfferNSEFFlag;
        if (giftCardOfferFFlag !== undefined) {
          const sandboxValue = window?.vzdl?.target?.sandbox || '';
          eventDispatcher('sendData', {
            name: 'Close',
            svars: {
              evar220: giftCardOfferFFlag ? `${sandboxValue}|${FIR_TAG_YES}` : `${sandboxValue}|${FIR_TAG_NO}`,
            },
          });
        }
      }
    }
  } catch (e) {
    console.debug('nbx feedback error:', e);
  }
}

function* getGiftCardOfferFFlag({payload}) {
  try {
    showLoader();
    let apiResponse = {};
    if(giftCardOfferAPI()) {
      apiResponse = { data: { giftCardOfferAALFFlag: true, giftCardOfferNSEFFlag: true } };
    } else {
      apiResponse = yield call(Actions.getFeatureFlagDetailAPI, payload);
    }
    if(apiResponse?.data[payload?.flagName]) {
      setSession('giftCardOfferFFlag', 'true');
      yield put({ type: actionTypes.GIFT_CARD_OFFER_MODAL_CLICKED, value: true });
    }
    hideLoader();
  } catch (e) {
    console.debug('getFeatureFlagDetail API error:', e);
  }
}


function* actionWatcher() {
  yield takeLatest(Constants.GET_CART_DETAILS_FROM_API, getCartDetails);
  yield takeLatest(Constants.ADD_ACCESSORIES, addToCart);
  yield takeLatest(Constants.ADD_ACCESSORIES_MV, addToCart);
  yield takeLatest(Constants.SHOW_CART, showCart);
  yield takeLatest(Constants.ADD_ON_ACCESS, addRemoveAccessory);
  yield takeLatest(Constants.GET_REVIEW_ORDER, getReviewOrderApi);
  yield takeLatest(Constants.GET_VALIDATE_ORDER, getValidateCartApi);
  yield takeLatest(Constants.UPDATE_SAVE_CART, saveCartApi);
  yield takeLatest(Constants.RESET_PROCEED_FLOW, resetProceedFlow);
  yield takeLatest(Constants.FETCH_AUTOFILL_ADDRESS, getAddressAutofill);
  yield takeLatest(Constants.FETCH_AUTOFILL_ADDRESS_UNIT, getAddressAutofillUnit);
  yield takeLatest(Constants.FETCH_AUTOFILL_ADDRESS_UNIT2, getAddressAutofillUnit2);
  yield takeLatest(Constants.FETCH_APICONFIG, get5GAppConfigURL);
  yield takeLatest('UPDATE_CART_DETAILS', updateCartAAL);
  yield takeLatest(Constants.ABANDON_CART_CALL, abandonCartCall);
  yield takeLatest(Constants.GET_SHIPPING_DET_FROM_API, getShippingInfoData);
  yield takeLatest(Constants.UPDATE_PROCESS_STEP_CART, updateProcesStepCart);
  yield takeLatest(Constants.IS_COUPON_VALID, isCouponValid);
  yield takeLatest(Constants.GET_MINI_CART, getMiniCart);
  yield takeLatest(Constants.CHECKOUT_DETAILS, checkoutDetails);
  yield takeLatest('APPLY_ABANDON_DISCOUNT_OFFER', applyAbandonDiscountOffer);
  yield takeLatest('UPDATE_BARCODE', updateBarcode);
  yield takeLatest('GET_NBX_OFFER_RECOMMENDATION', nbxOfferRecommendations);
  yield takeLatest('SUBMIT_NBX_FEEDBACK', submitNBXFeedback);
  yield takeLatest(Constants.GET_GIFT_CARD_OFFER_FFLAG, getGiftCardOfferFFlag);
  yield takeLatest(Constants.WIFI_UPDATE_CART, updateCart);
  yield takeLatest(Constants.REMOVE_CART_LINES, removeLines);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
